import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';
import api from '@/services';
import { courseLabel } from '@/libs';

const uuidv4 = require('uuid/v4');
const _ = require('lodash');
const moment = require('moment');
const { DateTime } = require('luxon');

const vuexPersist = new VuexPersist({
    key: 'my-app',
    storage: sessionStorage,
});

Vue.use(Vuex);
// eslint-disable-next-line
function generateCourseId({ subject, catalog_number, ssr_component, class_section, session_code, class_number, term }) {
    // eslint-disable-next-line
    return `${subject}${catalog_number}${ssr_component}${class_section}${session_code}${class_number}${term}`;
}

function initialState() {
    return {
        loggedin: false,
        tokens: {
        },
        creator: {
            ccid: '',
            name_ccid: '',
        },
        term_codes: [],
        term_grace_period_days: 0,
        subjects: [],
        ps_sections: [],
        ps_courses: [],
        creation_queue: [],
        canvas_course_request: {
            course_name: '',
            term: undefined,
            sections: [],
            roles: [],
            content: undefined,
            start_date: undefined,
            end_date: undefined,
            phone: undefined,
            havePermission: false,
            exclusions: {
                excludeannouncements: true,
            },
            type: 'credit',
        },
        request_type: 0,
        instr_courses: [],
        instr_ps_courses: [],
        canvas_instr_ps_courses: [],
        sandbox_id: -1,
        myrequests: [],
        myrequestsloading: false,
        myrequests_lastfetch: 0,
        isadmin: false,
        isstudent: true,
        issecondary: true,
        canvas_ps_sections: [],
        canvas_user_courses: [],
        canvas_my_requests: [],
        canvas_myrequests_loading: false,
        canvas_myrequests_lastfetch: 0,

    };
}

function addAttributesToPSCourseData({
    state, sterm, subject, catalognbr, termCodesHashed,
}) {
    return (filtered, psCourse) => {
        if ((!sterm && !subject && !catalognbr) || (psCourse.term === sterm && psCourse.subject === subject && psCourse.catalog_number === catalognbr)) {
            // creation_queue is an array of sections containing an array of ps_courses
            // ps_courses is a dictionary of course objects keyed by 'id'

            // Check all courses in all queued sections for this courses id. If one is found return false and add a queued indicator to the course object
            if (!_.every(state.creation_queue, (queuedSection) => _.every(queuedSection.coursedata, (queuedCourse) => queuedCourse.id !== psCourse.id))) {
                psCourse.isQueued = true;
                psCourse.$isDisabled = true;
            } else {
                psCourse.isQueued = false;
                psCourse.$isDisabled = false;
            }
            if (psCourse.created) {
                psCourse.$isDisabled = true;
            }
            psCourse.label = courseLabel(psCourse, termCodesHashed);
            filtered.push(psCourse);
        }
        return filtered;
    };
}

function checkInstrCourseStatus({ state, termCodesHashed }) {
    return (filtered, instrCourse) => {
        if (state.canvas_course_request.sections.some((section) => section.id === instrCourse.id)) {
            instrCourse.isQueued = true;
            instrCourse.$isDisabled = true;
        } else {
            instrCourse.isQueued = false;
            instrCourse.$isDisabled = false;
        }
        if (instrCourse.created) {
            instrCourse.$isDisabled = true;
        }
        instrCourse.label = courseLabel(instrCourse, termCodesHashed);
        filtered.push(instrCourse);
        return filtered;
    };
}

export default new Vuex.Store({
    plugins: [vuexPersist.plugin],
    state: initialState(),
    mutations: {
        SET_CREATOR: (state, payload) => {
            state.creator = payload;
        },
        SET_REQUEST_TYPE: (state, payload) => {
            state.request_type = payload;
        },
        SET_TERM_CODES: (state, payload) => {
            state.term_codes = payload;
        },
        SET_TERM_GRACE_PERIOD_DAYS: (state, payload) => {
            state.term_grace_period_days = payload;
        },
        SET_MY_REQUESTS: (state, payload) => {
            state.myrequests = payload;
            state.myrequests_lastfetch = moment().unix();
        },
        SET_MY_REQUESTS_LOADING: (state, payload) => {
            state.myrequestsloading = payload;
        },
        SET_CANVAS_MY_REQUESTS: (state, payload) => {
            state.canvas_my_requests = payload;
            state.canvas_myrequests_lastfetch = DateTime.now().toSeconds();
        },
        SET_CANVAS_MY_REQUESTS_LOADING: (state, payload) => {
            state.canvas_myrequests_loading = payload;
        },
        SET_SUBJECTS: (state, payload) => {
            state.subjects = payload;
        },
        SET_PS_SECTIONS: (state, payload) => {
            state.ps_sections = payload;
        },
        SET_PS_COURSES: (state, payload) => {
            state.ps_courses = payload;
        },
        SET_INSTR_COURSES: (state, payload) => {
            state.instr_courses = payload;
        },
        SET_CANVAS_USER_COURSES: (state, payload) => {
            state.canvas_user_courses = payload;
        },
        SET_CANVAS_ROLES: (state, payload) => {
            state.canvas_course_request.roles = payload;
        },
        SET_CANVAS_COURSE_REQUEST_ATTRIBUTES: (state, payload) => {
            Object.entries(payload).forEach(([key, value]) => {
                Vue.set(state.canvas_course_request, key, value);
            });
        },
        SET_PS_INSTR_COURSES: (state, payload) => {
            state.instr_ps_courses = payload;
        },
        SET_CANVAS_PS_INSTR_COURSES: (state, payload) => {
            state.canvas_instr_ps_courses = payload;
        },
        SET_CREATION_QUEUE: (state, payload) => {
            state.creation_queue = payload;
        },
        SET_CANVAS_COURSE_REQUEST: (state, payload) => {
            state.canvas_course_request = payload;
        },
        ADD_CANVAS_COURSE_REQUEST_SECTION: (state, payload) => {
            if (!state.canvas_course_request.sections) {
                state.canvas_course_request.sections = [];
            }
            state.canvas_course_request.sections.push(payload);
        },
        REMOVE_CANVAS_COURSE_REQUEST_SECTION: (state, payload) => {
            state.canvas_course_request.sections = state.canvas_course_request.sections.filter((section) => section.id !== payload.id);
        },
        SET_CANVAS_PS_SECTIONS: (state, payload) => {
            state.canvas_ps_sections = payload;
        },
        SET_PROPERTY_IN_QUEUED_COURSE: (state, payload) => {
            const index = state.creation_queue.findIndex((element) => element.id === payload.id);
            _.merge(state.creation_queue[index], payload);
        },
        // Add an item to the end of the creation queue
        ADD_CREATION_QUEUE: (state, payload) => {
            state.creation_queue.push(payload);
        },
        // Add an item to the end of the coursedata of specified course in the creation queue
        ADD_PSCOURSES_TO_QUEUED_COURSE: (state, { id, pscourses }) => {
            if (state.creation_queue.length > 0) {
                const index = state.creation_queue.findIndex((element) => element.id === id);
                let coursedata = _.concat(state.creation_queue[index].coursedata, pscourses);
                coursedata = _.uniqBy(coursedata, 'id');
                state.creation_queue[index].coursedata = coursedata;
            }
        },
        // Remove an item at specified index from the creation queue
        REMOVE_CREATION_QUEUE: (state, id) => {
            if (id !== undefined) {
                // filter the array for the specified course
                state.creation_queue = state.creation_queue.filter((course) => course.id !== id);
            }
        },
        REMOVE_SECTION_FROM_COURSE_IN_CREATION_QUEUE: (state, { courseid, sectionid }) => {
            if (state.creation_queue.length > 0 && courseid !== undefined && sectionid !== undefined) {
                // filter coursedata for the specified course
                const index = state.creation_queue.findIndex((element) => element.id === courseid);
                state.creation_queue[index].coursedata = state.creation_queue[index].coursedata.filter((section) => section.id !== sectionid);
            }
        },
        SET_QUEUED_COURSE_OPEN_DATE: (state, payload) => {
            state.creation_queue[payload.index].opendate = payload.date;
        },
        SET_QUEUED_COURSE_CLOSE_DATE: (state, payload) => {
            state.creation_queue[payload.index].closedate = payload.date;
        },
        SET_SANDBOX: (state, payload) => {
            state.sandbox_id = payload;
        },
        RESET_CANVAS_COURSE_REQUEST: (state) => {
            state.canvas_course_request = initialState().canvas_course_request;
            state.request_type = 0;
        },
        RESET_CREATION_QUEUE_SIMPLE: (state) => {
            if (state.creation_queue.length > 1) {
                state.creation_queue = [state.creation_queue[0]];
            }
        },
        RESET_CREATION_QUEUE_COMPLETELY: (state) => {
            state.creation_queue = [];
        },
        RESET_BETWEEN_REQUESTS: (state) => {
            const s = initialState();
            Object.keys(s).forEach((key) => {
                // Reset everything except for user/session related fields.
                if (key === 'loggedin' || key === 'tokens' || key === 'isadmin' || key === 'isstudent' || key === 'issecondary') {
                    return;
                }
                state[key] = s[key];
            });
        },
        SET_IS_ADMIN: (state, isadmin) => {
            state.isadmin = isadmin;
        },
        SET_IS_STUDENT: (state, isStudent) => {
            state.isstudent = isStudent;
        },
        SET_IS_SECONDARY: (state, isSecondary) => {
            state.issecondary = isSecondary;
        },
        SET_LOGGED_IN: (state, status) => {
            state.loggedin = status;
        },
        SET_TOKENS: (state, payload) => {
            state.tokens = payload;
        },
        LOGOUT: (state) => {
            state.tokens = {};
            state.loggedin = false;
        },
    },
    actions: {
        FETCH_ROLES: async (context) => {
            try {
                const response = await api.getRoles();
                context.commit('SET_IS_ADMIN', response.data.isAdmin);
                context.commit('SET_IS_STUDENT', response.data.isStudent);
                context.commit('SET_IS_SECONDARY', response.data.isSecondary);
            } catch (error) {
                console.error(error);
            }
        },
        SET_CREATOR: async (context, payload) => {
            if (!payload.ccid || !payload.name_ccid) {
                console.error(`Invalid creator data (${JSON.stringify(payload)})`);
                throw new Error(`Invalid creator data (${JSON.stringify(payload)})`);
            }
            context.commit('SET_CREATOR', payload);
        },
        FETCH_TERM_CODES: async (context) => {
            const termcodes = { terms: [], termGracePeriodDays: 0 };

            try {
                const response = await api.getTerms();

                // todo: merge this with existing state to not rebuild whole object every time there is a change?
                response.data.terms.forEach((term) => {
                    termcodes.terms.push(
                        {
                            code: term.term,
                            fullname: term.description,
                            startdate: term.begin_datetime,
                            enddate: term.end_datetime,
                        },
                    );
                });
                termcodes.termGracePeriodDays = response.data.termGracePeriodDays || 0;
            } catch (error) {
                console.error(error);
            }
            context.commit('SET_TERM_CODES', termcodes.terms);
            context.commit('SET_TERM_GRACE_PERIOD_DAYS', termcodes.termGracePeriodDays);
        },
        FETCH_MY_REQUESTS: async (context) => {
            let response;
            context.commit('SET_MY_REQUESTS_LOADING', true);
            try {
                response = await api.getRequests();
                response.data.Items.sort((a, b) => b.date - a.date);
                context.commit('SET_MY_REQUESTS', response.data.Items);
                context.commit('SET_MY_REQUESTS_LOADING', false);
            } catch (error) {
                console.error(error);
            }
        },
        FETCH_CANVAS_MY_REQUESTS: async (context) => {
            let response;
            context.commit('SET_CANVAS_MY_REQUESTS_LOADING', true);
            try {
                response = await api.getCanvasRequestorRequests();
                context.commit('SET_CANVAS_MY_REQUESTS', response.data.items);
                context.commit('SET_CANVAS_MY_REQUESTS_LOADING', false);
            } catch (error) {
                console.error(error);
            }
        },
        GET_SUBJECTS: async (context, payload) => {
            // payload should contain a term to filter the api call with

            const subjects = [];

            try {
                const response = await api.getSubjects(payload.term.code);

                // todo: merge this with existing state to not rebuild whole object every time there is a change?
                response.data.subjects.forEach((subject) => {
                    subjects.push(
                        {
                            term: response.data.selected_term,
                            name: subject,
                        },
                    );
                });
            } catch (error) {
                console.error(error);
            }

            context.commit('SET_SUBJECTS', subjects);
        },
        GET_PS_SECTIONS: async (context, payload) => {
            // payload should contain a term and subject to filter the api call with

            const sections = [];

            try {
                const response = await api.getCatalogNumbers(payload.term.code, payload.subject.name);

                // todo: merge this with existing state to not rebuild whole object every time there is a change?
                response.data.subjects.forEach((subject) => {
                    sections.push(
                        {
                            term: response.data.selected_term,
                            subject: response.data.selected_subject,
                            catalog_number: subject.catalog_number,
                            idkey: `${response.data.selected_subject}-${subject.catalog_number}`,
                            description: `${response.data.selected_subject + subject.catalog_number}-${subject.description}`,
                        },
                    );
                });
            } catch (error) {
                console.error(error);
            }

            context.commit('SET_PS_SECTIONS', sections);
        },
        GET_PS_COURSES: async (context, payload) => {
            // payload should contain a term, subject, and catalog number to filter the api call with

            const courseSections = {};

            try {
                const response = await api.getSections(payload.term.code, payload.subject.name, payload.catalognbr.catalog_number);

                // todo: merge this with existing state to not rebuild whole object every time there is a change?
                response.data.sections.forEach((section) => {
                    const key = generateCourseId(section);
                    // Avoid adding duplicates (since the api returns one course entry for each instructor in each course)
                    if (_.has(courseSections, key)) {
                        courseSections[key].ccid.push(section.ccid);
                    } else {
                        courseSections[key] = {
                            id: key,
                            term: section.term,
                            subject: section.subject,
                            catalog_number: section.catalog_number,
                            class_type: section.class_type,
                            session_code: section.session_code,
                            class_section: section.class_section,
                            ssr_component: section.ssr_component,
                            acad_group: section.acad_group,
                            acad_org: section.acad_org,
                            description: section.description,
                            class_number: section.class_number,
                            course_id: section.course_id,
                            ccid: [section.ccid],
                            // eslint-disable-next-line
                            created: section.requested, // section.exists
                        };
                    }
                });
            } catch (error) {
                console.error(error);
            }

            context.commit('SET_PS_COURSES', courseSections);
        },
        // fetch section data from the backend
        GET_CANVAS_PS_SECTIONS: async ({ commit }, payload) => {
            // payload should contain a term, subject to filter the api call with

            try {
                const response = await api.getCanvasSections(payload.term.code, payload.subject.name);
                commit('SET_CANVAS_PS_SECTIONS', response.data);
            } catch (error) {
                console.error(error);
            }
        },
        GET_INSTR_COURSES: async (context, payload) => {
            // payload should contain a ccid to filter the api call with

            const sections = [];

            try {
                const response = await api.getInstructorEclassCourses(payload);

                // todo: merge this with existing state to not rebuild whole object every time there is a change?
                response.data.forEach((course) => {
                    sections.push(
                        {
                            id: course.id,
                            shortname: course.shortname,
                            fullname: course.fullname,
                        },
                    );
                });
                sections.sort((a, b) => (b.id - a.id)); // Larger course id numbers at top of list.
            } catch (error) {
                console.error(error);
            }

            context.commit('SET_INSTR_COURSES', sections);
        },
        GET_CANVAS_USER_COURSES: async (context) => {
            const sections = [];

            try {
                const response = await api.getCanvasUserCourses();

                // todo: merge this with existing state to not rebuild whole object every time there is a change?
                response.data.forEach((course) => {
                    sections.push(
                        {
                            id: course.id,
                            name: course.name,
                            term: course.term,
                        },
                    );
                });
                sections.sort((a, b) => (b.id - a.id)); // Larger course id numbers at top of list.
            } catch (error) {
                console.error(error);
            }

            context.commit('SET_INSTR_COURSES', sections);
        },
        GET_PS_INSTR_COURSES: async (context, payload) => {
            const courseSections = {};

            try {
                const response = await api.getInstructorEclassCoursesByTerm(payload.ccid, payload.term);

                // todo: merge this with existing state to not rebuild whole object every time there is a change?
                response.data.classes.forEach((course) => {
                    const key = generateCourseId(course);
                    // Avoid adding duplicates (since the api returns one course entry for each instructor in each course)
                    if (_.has(courseSections, key)) {
                        courseSections[key].CAMPUS_ID.push(course.CAMPUS_ID);
                    } else {
                        courseSections[key] = {
                            id: key,
                            term: course.term,
                            subject: course.subject,
                            catalog_number: course.catalog_number,
                            class_type: course.class_type,
                            session_code: course.session_code,
                            class_section: course.class_section,
                            ssr_component: course.ssr_component,
                            acad_group: course.acad_group,
                            acad_org: course.acad_org,
                            description: course.description,
                            class_number: course.class_number,
                            course_id: course.course_id,
                            ccid: [course.ccid],
                            // eslint-disable-next-line
                            created: course.requested, // section.exists
                        };
                    }
                });
            } catch (error) {
                console.error(error);
            }

            context.commit('SET_PS_INSTR_COURSES', courseSections);
        },
        FETCH_CANVAS_PS_INSTR_COURSES: async (context, payload) => {
            const InstrSections = [];
            try {
                const response = await api.getCanvasInstrCourses(payload.term);
                response.data.forEach((course) => {
                    /* eslint-disable no-underscore-dangle */
                    InstrSections.push({
                        id: course.id,
                        term: course.term,
                        subject: course.subject,
                        catalog_number: course.course_number,
                        class_section: course.section_name,
                        ssr_component: course.component,
                        class_number: course.class_number,
                        name: course.name,
                        status: course.status,
                        created: course.status === 'REQUESTED', // section.exists
                        /* eslint-enable no-underscore-dangle */
                    });
                });
                context.commit('SET_CANVAS_PS_INSTR_COURSES', InstrSections);
            } catch (error) {
                console.error(error);
            }
        },
        GET_SANDBOX_ID: async (context, payload) => {
            try {
                const response = await api.getSandboxId(payload);
                context.commit('SET_SANDBOX', response.data);
            } catch (error) {
                console.error(error);
            }
        },
        /**
         * Adds a course skeleton to queue.
         * @param {*} payload Must contain 'combined' (bool), courselist (array). Any other attributes (execpt id) will overwrite the attribute
         */
        ADD_TO_CREATION_QUEUE: async ({ commit }, payload) => {
            if (payload.combined === undefined || payload.courselist === undefined) {
                throw new Error('Missing required attributes (combined, courselist) in ADD_TO_CREATION_QUEUE');
            }
            const item = {
                id: uuidv4(),
                combined: undefined,
                coursedata: [],
                name: '',
                content: '',
                wantExclusions: false,
                havePermission: false,
                phone: '',
                department: '',
                roleInstructor: [],
                roleTA: [],
                roleNonEditTA: [],
                roleDesigner: [],
                roleStudents: '',
                opendate: '',
                closedate: '',
                contentComplete: false,
                rolesComplete: false,
                datesComplete: false,
            };
            // Apply all payload attributes except id
            Object.keys(payload).forEach((key) => {
                let mappedKey = key;
                if (key !== 'id') {
                    // re-write the courselist attribute because legacy...
                    if (key === 'courselist') {
                        mappedKey = 'coursedata';
                    }
                    item[mappedKey] = payload[key];
                }
            });

            commit('ADD_CREATION_QUEUE', item);
        },
        GET_DEFAULT_FULLNAME: async (context, payload) => {
            const response = await api.generateDefaultFullName(payload);
            return response.data;
        },
        ADD_PSCOURSES_TO_QUEUED_COURSE: async ({ commit }, { id, pscourses }) => {
            commit('ADD_PSCOURSES_TO_QUEUED_COURSE', { id, pscourses });
        },
        REMOVE_FROM_CREATION_QUEUE: async (context, id) => {
            context.commit('REMOVE_CREATION_QUEUE', id);
        },
        REMOVE_ITEM_FROM_COURSE_IN_CREATION_QUEUE: async (context, payload) => {
            context.commit('REMOVE_SECTION_FROM_COURSE_IN_CREATION_QUEUE', payload);
        },
        RESET_CREATION_QUEUE_TO_SIMPLE: async (context) => {
            context.commit('RESET_CREATION_QUEUE_SIMPLE');
        },
        FETCH_TOKENS: async ({ commit }, payload) => {
            try {
                const response = await api.exchangeCodeForTokens(payload);
                const expiry = new Date();
                expiry.setHours(expiry.getHours() + 1);
                response.data.expiry = expiry;
                commit('SET_TOKENS', response.data);
                commit('SET_LOGGED_IN', true);
            } catch (e) {
                commit('SET_TOKENS', {});
                commit('SET_LOGGED_IN', false);
            }
        },
        REFRESH_TOKENS: async ({ commit, state }) => {
            try {
                const response = await api.refreshTokens(state.tokens);
                const expiry = new Date();
                expiry.setHours(expiry.getHours() + 1);
                response.data.expiry = expiry;
                commit('SET_TOKENS', response.data);
                commit('SET_LOGGED_IN', true);
            } catch (e) {
                commit('SET_TOKENS', {});
                commit('SET_LOGGED_IN', false);
            }
        },
    },
    getters: {
        SUBJECTS: (state) => (sterm) => state.subjects.reduce((filtered, subject) => {
            if (subject.term === sterm) {
                filtered.push(subject);
            }
            return filtered;
        }, []),
        PS_SECTIONS: (state) => (sterm, subject) => state.ps_sections.reduce((filtered, section) => {
            if (section.term === sterm && section.subject === subject) {
                filtered.push(section);
            }
            return filtered;
        }, []),
        PS_INSTR_COURSES: (state, getters) => () => {
            const psCourses = _.values(state.instr_ps_courses);
            const termCodesHashed = getters.TERM_CODES_HASHED;
            return psCourses.reduce(addAttributesToPSCourseData({
                state,
                termCodesHashed,
            }), []);
        },
        CANVAS_PS_INSTR_COURSES: (state, getters) => () => {
            const instrCourses = state.canvas_instr_ps_courses;
            const termCodesHashed = getters.TERM_CODES_HASHED;
            return instrCourses.reduce(checkInstrCourseStatus({
                state,
                termCodesHashed,
            }), []);
        },
        PS_COURSES: (state, getters) => (sterm, subject, catalognbr) => {
            const psCourses = _.values(state.ps_courses);
            const termCodesHashed = getters.TERM_CODES_HASHED;
            return psCourses.reduce(addAttributesToPSCourseData({
                state,
                sterm,
                subject,
                catalognbr,
                termCodesHashed,
            }), []);
        },
        TERM_CODES: (state) => state.term_codes,
        TERM_GRACE_PERIOD_DAYS: (state) => state.term_grace_period_days,
        TERM_CODES_HASHED: (state) => {
            const hterms = {};
            _.each(state.term_codes, (term) => {
                hterms[term.code] = term;
            });
            return hterms;
        },
        CREATION_QUEUE: (state, getters) => state.creation_queue.map((course) => {
            course.coursedata = course.coursedata.map((section) => {
                if (section) {
                    section.label = courseLabel(section, getters.TERM_CODES_HASHED);
                }
                return section;
            });
            return course;
        }),
        NEXT_TERM: (state) => {
            // Set to 1 month ago so that current term is default for 1 month into the current term before switching to next.
            const currentDate = moment().subtract(1, 'months');
            // Dummy data
            let nextTerm = {
                code: 404,
                fullname: 'Term Not Found',
                startdate: moment().add(365, 'days'),
                enddate: moment().add(365, 'days'),
            };

            // This search looks for the term with the closest start date to the current date:
            state.term_codes.forEach((term) => {
                const startDate = moment(term.startdate);
                if (startDate.isSameOrAfter(currentDate)
                    && startDate.isSameOrBefore(nextTerm.startdate)
                    && !_.startsWith(term.fullname, 'PGME')
                    && !_.startsWith(term.fullname, 'Continuing')) {
                    nextTerm = term;
                }
            });
            if (nextTerm.code === 404) {
                console.error('error fetching the next term');
            }
            return nextTerm;
        },
        GET_CREATOR_CCID: (state) => state.creator.ccid,
        GET_CREATOR: (state) => state.creator,
        MY_REQUESTS: (state) => {
            const myreq = state.myrequests.map((item) => {
                switch (item.statestatus) {
                case 'Processing Completed Successfully':
                    item.statestatus = 'Course Created';
                    break;
                case 'Approval denied':
                case 'Deleted by admin':
                    item.statestatus = 'Cancelled';
                    break;
                default:
                    item.statestatus = 'In Progress';
                }
                return item;
            });
            return myreq;
        },
        CANVAS_MY_REQUESTS: (state) => {
            /* eslint-disable no-underscore-dangle */
            const canmyreq = state.canvas_my_requests.map((item) => {
                item.createdOn = new Date(item.createdOn * 1000).toLocaleString();
                switch (item.status) {
                case 'COMPLETED':
                    item.status = 'Course Created';
                    break;
                case 'DENIED':
                    item.status = 'Approval Denied';
                    break;
                case 'DELETED':
                    item.status = 'Cancelled';
                    break;
                case 'FAILED':
                    item.status = 'Course Failed';
                    break;
                default:
                    item.status = 'In Progress';
                }
                return item;
            });
            return canmyreq;
            /* eslint-enable no-underscore-dangle */
        },
    },
});
